import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import MasterTemplate from '@appbase/templates/MasterTemplate.vue'

@Component({
  components: { MasterTemplate },
})
export default class InnoNLife extends Vue {

  created(){
    this.setPage({title:'인라이프'})
  }
  innoNPopup(){
    window.open('https://inno-n.ezwel.com','_blank','width=1200,height=899');
  }
}
